var render = function render(){var _vm=this,_c=_vm._self._c;return _c('termos-de-uso',{on:{"voltar":function($event){return _vm.$router.go(-1)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }